import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import CommonLoader from '../../../shared/loaders/CommonLoader';
import SplitTasksTable from './SplitTasksTable';

const SplitTasks = ({ loading, selectedTasks, setSelectedTasks }) => {
  const visitTasks = useSelector((state) => state.visitTasks.visitTasks);

  const handleSelect = (task) => {
    setSelectedTasks((prevSelectedTasks) =>
      prevSelectedTasks.includes(task.id)
        ? prevSelectedTasks.filter((taskId) => taskId !== task.id)
        : [...prevSelectedTasks, task.id],
    );
  };

  const handleSelectAll = () => {
    if (selectedTasks.length === visitTasks.length) {
      setSelectedTasks([]);
    } else {
      setSelectedTasks(visitTasks.map((task) => task.id));
    }
  };

  return visitTasks.length ? (
    <div className="flex flex-col gap-3 md:gap-4">
      <Suspense fallback={<CommonLoader />}>
        <div className="w-fit flex justify-start font-header2 text-xs md:text-sm text-bg5">
          Виберіть послуги для перенесення
        </div>
        <SplitTasksTable
          visitTasks={visitTasks}
          selectedTasks={selectedTasks}
          onVisitTaskSelect={handleSelect}
          onSelectAll={handleSelectAll}
          allSelected={selectedTasks.length === visitTasks.length}
        />
      </Suspense>
    </div>
  ) : (
    <></>
  );
};

export default SplitTasks;
